/* WhatsApp deep-link helper.
   Builds api.whatsapp.com/send URLs with a pre-filled custom message
   per call-to-action (no shared link with predetermined emoji/text). */

const PHONE = "56951013260";

export function waLink(message) {
  const text = encodeURIComponent(message || "");
  return `https://api.whatsapp.com/send?phone=${PHONE}&text=${text}`;
}

export const WA_MSG = {
  demo:     "Hola! quiero agendar una demo de cliente recurrente",
  activar:  "Hola! quiero activar cliente recurrente en mi e-commerce",
  costo:    "Hola! quiero saber más sobre costos y comenzar con cliente recurrente",
  duda:     "Hola! tengo una duda sobre cliente recurrente",
};
